import classNames from 'classnames'
import React from 'react'
import { SwitchField, TextField } from 'scenes/Dashboard/components-next/Forms/Controllers'
import { FormSection } from 'scenes/Dashboard/components-next/Sections'
import { FastField } from 'utils-next/forms'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { cx } from 'tss-react/@emotion/css'

import { useCorporateDataFormStyles } from './CorporateDataForm.styles'
import { UserRoleSelect, UserStatusSelect } from './components'

export type UserCommonDataProps = ExtendableStyles & Testable

export function UserCommonData({ ...styleProps }: UserCommonDataProps) {
  const { classes } = useCorporateDataFormStyles()
  return (
    <FormSection title="User information" {...styleProps} className={cx(styleProps.className, classes.formUserSection)}>
      <div className={classes.formContainer}>
        <FastField className={classes.field} component={TextField} label="First name" name="firstName" required />
        <FastField className={classes.field} component={TextField} label="Last name" name="lastName" required />
      </div>
      <div className={classes.formContainer}>
        <FastField className={classes.field} component={TextField} label="Email" name="email" required />
        <FastField
          component={UserStatusSelect}
          className={classes.field}
          label="User status"
          name="status"
          disableClearable
          required
        />
      </div>
      <div className={classes.formContainer}>
        <FastField className={classes.field} component={TextField} label="Position" name="position" />
        <FastField component={UserRoleSelect} className={classes.field} label="User role" name="role" required />
      </div>
      <div className={classNames(classes.field, classes.booleanFields)}>
        <FastField
          type="checkbox"
          component={SwitchField}
          label="Admin user"
          name="admin"
          className={classes.inlineField}
        />
        <FastField
          type="checkbox"
          component={SwitchField}
          label="Onboarding on login"
          name="askForOnboarding"
          className={classes.inlineField}
        />
        <FastField
          type="checkbox"
          component={SwitchField}
          label="Highlighted"
          name="highlighted"
          className={classes.inlineField}
        />
      </div>
    </FormSection>
  )
}
